module.exports = __webpack_public_path__ + "img/ic_about.dc9a1cd5.png";